import { useQuery } from 'react-query';
import { getInstantMessageDrafts } from '~src/services/api/movements';

interface UseInstantMessageDraftsProps {
  projectId?: number;
  tenderId: string | number;
  enabled?: boolean;
}

export const useInstantMessageDrafts = ({
  projectId,
  tenderId,
  enabled = true,
}: UseInstantMessageDraftsProps) => {
  return useQuery(
    ['instant_message_drafts', projectId, tenderId],
    () =>
      getInstantMessageDrafts({
        projectId: projectId!,
        tenderId: Number(tenderId),
      }),
    {
      enabled: enabled && !!projectId && !!tenderId,
      refetchOnWindowFocus: false,
    }
  );
};
